import moment from 'moment'
import { SET_APPLICANTS_FORM_DATA } from '../applicantsReducer'

const initialState = {
  org: '0',
  school: '0',
  date_from: moment().subtract(2, 'months').format('YYYY-MM-DD'),
  date_to: moment().format('YYYY-MM-DD'),
  fio: '',
}

export const applicantsFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_APPLICANTS_FORM_DATA:
      return action.payload
    default:
      return state
  }
}
